/**
 * V70G8J — 게임대회 대시보드 KST 날짜 표시 (기존 대시보드 포맷터와 같은 방식: +9h 후 UTC 필드 사용)
 *   중계 일정도 하단 대진표 카드 게시일과 같은 YYYY-MM-DD 형식으로 표시한다. 값·시간대 계산은 변경 없음.
 */
const pad = (n: number) => String(n).padStart(2, '0');

/** ms(epoch) → "YYYY-MM-DD HH:mm" (KST). 0/NaN → "-" */
export function fmtKstDateTime(ms: number): string {
  if (!ms || !Number.isFinite(ms)) return '-';
  const d = new Date(ms + 9 * 3600 * 1000);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}
